/*
  Alpha Zen redesign: the toggle between the two loop diagrams.

  From room.html. The toggle above the diagram flips between "The stimulant
  loop" and "The alpha zen loop": same five positions, a different day. The
  caption under the diagram changes with it.
*/
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-az-loop]').forEach(function (wrap) {
      if (wrap.dataset.azReady === 'true') return;
      wrap.dataset.azReady = 'true';

      const buttons = wrap.querySelectorAll('.lt button[data-loop]');
      const diagrams = wrap.querySelectorAll('.loop');
      const captions = wrap.querySelectorAll('.loopcap');

      function show(which) {
        buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', button.dataset.loop === which ? 'true' : 'false');
        });
        diagrams.forEach(function (diagram) {
          diagram.classList.toggle('on', diagram.classList.contains(which));
        });
        captions.forEach(function (caption) {
          caption.hidden = caption.dataset.for !== which;
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          show(button.dataset.loop);
        });
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
